import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterBonusReport from 'views/customers/reports/bonusReport/filterBonusReport'; // Importing filter component for bonus report
import TableBonusReport from 'views/customers/reports/bonusReport/tableBonusReport'; // Importing table component for bonus report
import DetailsBonusReport from 'views/customers/reports/bonusReport/detailsBonusReport'; // Importing details component for bonus report
import RecordBonusReport from 'views/customers/reports/bonusReport/recordBonusReport'; // Importing record component for bonus report
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the Bonus Report View.
 * @extends JetView
 */
export default class BonusReportView extends JetView {
    /**
     * Configures the UI components for the Bonus Report View.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Right section configuration with record and details components
        const right = {
            type: 'wide',
            minWidth: 200,
            rows: [RecordBonusReport, DetailsBonusReport],
        };

        // Toolbar configuration with pagination
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from configuration
                },
            ],
        };

        // Left section configuration with toolbar, filter, table, and toolbar
        const left = {
            height: screen.width < 500 ? 500 : 0, // Conditional height based on screen width
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Applying the current theme
                    elements: [
                        {
                            view: 'label',
                            label: _('Reporte de Bonos'), // Localized label for the report
                            width: 250,
                        },
                    ],
                },
                FilterBonusReport, // Filter component for the report
                TableBonusReport, // Table component for displaying report data
                toolbar, // Including the previously defined toolbar
            ],
        };

        webix.ui.fullScreen(); // Setting the UI to full screen mode

        // Returning the main configuration object for the view
        return {
            id: 'a5', // Unique identifier for the view
            type: 'clean', // Clean type for the view
            view: 'form', // Form view type
            rows: [
                {
                    responsive: 'a5', // Responsive design identifier
                    type: 'wide', // Wide type for layout
                    cols: [left, right], // Including left and right sections
                },
            ],
        };
    }
}

// FILE DOCUMENTED
